module.exports = __webpack_public_path__ + "static/don8-17a606e78d7de45e6f2067a1b3d5a8dc.jpg";